export default "__VITE_ASSET__BbZd4SRW__ 640w, __VITE_ASSET__DOglkDo___ 1024w";